module.exports = __webpack_public_path__ + "img/Empty.4d574b70.svg";